module.exports = __webpack_public_path__ + "img/886b23d.png";